import React from 'react';
import { Typography, LinearProgress } from '@mui/material';

import './loading.styles.scss';

export default function Loading() {
  return (
    <div id='loading-modal'>
      <div id='loading-bar-cont'>
        <Typography>Loading resources ...</Typography>
        <LinearProgress variant='indeterminate' />
      </div>
    </div>
  );
}
